import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  Outlet,
} from "react-router-dom";
import FAQSection from "./Components/FAQs/FAQSection";
import Layout from "./Components/Layout/Layout";
import OrderLayout from "./Components/OrderLayout";
import ProfileLayout from "./Components/ProfileLayout";
import AboutUsPage from "./Pages/about-us";
import ContactUs from "./Pages/contact-us";
import ForgotPassword from "./Pages/forgot-password";
import HomePage from "./Pages/home";
import Login from "./Components/Login";
import OrderAddress from "./Pages/order/address/address";
import OrderConformationPage from "./Pages/order/confirmOrder/confirmOrder";
import OrderInstructions from "./Pages/order/instructions/instructions";
import Billing from "./Pages/profile/billing";
import ChangePassword from "./Pages/profile/change-password";
import ContactInfo from "./Pages/profile/contact-info";
import Orders from "./Pages/profile/orders";
import PurchaseInfo from "./Pages/profile/purchase";
import ReportsPage from "./Pages/reports";
import ResetPassword from "./Pages/reset-password";
import Signup from "./Pages/signup";
import SaveNewPassword from "./Pages/SaveNewPassword";
import Order from "./Components/Orders/Order";
import Purchase from "./Components/Orders/Purchase";
import PurchaseSummary from "./Components/Orders/PurchaseSummary";
import UserDetailsLayout from "./Pages/CreditsPurchase/UserDetailsLayout";
import CreditsPurchase from "./Pages/CreditsPurchase/CreditsPurchase";
import ProfileInfo from "./Pages/profile/profile-info";
import BillingDetails from "./Pages/profile/billing-details";
import DeliveryPreferences from "./Pages/profile/delivery-preferences";
import OrderHistory from "./Pages/profile/order-history";
import { AuthProvider, useAuth } from "./context/AuthContext";


const ProtectedRoute = () => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export const AppRoutes = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/about-us" element={<AboutUsPage />} />
            <Route path="/faq" element={<FAQSection />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/password-reset" element={<SaveNewPassword />} />
            <Route path="/contact-us" element={<ContactInfo />} />
            <Route path="/reports" element={<ReportsPage />} />
 <Route path="/order-page" element={<Order />} />
            <Route element={<ProtectedRoute />}>
             
              <Route
                path="/UserDetailsLayout"
                element={<UserDetailsLayout />}
              />

              <Route path="/profile" element={<ProfileLayout />}>
                <Route path="change-password" element={<ChangePassword />} />
                <Route path="orders" element={<Orders />} />
                <Route path="billing" element={<Billing />} />
                <Route path="order-history" element={<OrderHistory />} />
                <Route path="profile-info" element={<ProfileInfo />} />
                <Route path="purchase" element={<PurchaseInfo />} />
                <Route path="credits-purchase" element={<CreditsPurchase />} />
                <Route path="billing-info" element={<BillingDetails />} />
                <Route path="index" element = {<BillingDetails/>} />
                <Route
                  path="delivery-preferences"
                  element={<DeliveryPreferences />}
                />
              </Route>

              <Route path="/order" element={<OrderLayout />}>
                <Route path="address" element={<OrderAddress />} />
                <Route path="instructions" element={<Purchase />} />
                <Route
                  path="order-confirmation"
                  element={<OrderConformationPage />}
                />
                <Route path="PurchaseSummary" element={<PurchaseSummary />} />
                <Route
                  path="confirmOrder"
                  element={<OrderConformationPage />}
                />
              </Route>
            </Route>
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
};
